import React, { useEffect, useMemo, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import GlobalTable from '../../../components/CustomTableWithPagination/GlobalTable';
import { studentSessionAnalyticsHeader } from './utils/studentSessionAnayticsHeader';
import { useDispatch } from 'react-redux';
import { getAllProjects } from '../../../redux/features/courseSlice';
import { useSelector } from 'react-redux';
import GlobalSelectFieldWithoutFormikNew from '../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { getCROlistUnderProject } from '../../../redux/features/CRDslice';
import { isSameUserType } from '../../../utils/helperFunction';
import { croTypeNames } from '../../../utils/employeeTypes';
import { getStudentSessionAnalyticsTable } from '../../../redux/features/crdMigrationSlice';
import dayjs from 'dayjs';
import { MONTHS_WITHOUT_ALL } from '../../../utils/courseIncome/constaints';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FOUNDATION_DEPARTMENT_ID } from '../../../utils/constants/departmentDetails';

export default function StudentSessionAnalytics() {
  // normal variable
  const dispatch = useDispatch();

  // Redux State-------------------------------------------------------------
  const allProjects = useSelector((state) => state.course.projects);
  const courseLoading = useSelector((state) => state.course.loading);
  const crosunderproject = useSelector((state) => state.crd.crosunderproject);
  const loading = useSelector((state) => state.crdMigration.studentSessionAnalyticsTable.loading);
  const studentSessionAnalyticsTable = useSelector((state) => state.crdMigration.studentSessionAnalyticsTable.data);
  const meta = useSelector((state) => state.crdMigration.studentSessionAnalyticsTable.meta);
  //--------------------------------------------------------------------------

  // react state
  const [project, setProject] = useState({ id: -1, name: 'All' });
  const [month, setMonth] = useState({ id: dayjs().month() + 1, value: '' });
  const [year, setYear] = useState(dayjs().year());

  const [cro, setCRO] = useState(null);
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  // checking is CRO or not
  const isCro = useMemo(() => {
    const profile = JSON.parse(localStorage.getItem('cred')).profile;
    return isSameUserType({ roleArray: croTypeNames, role: profile?.role });
  }, []);

  // EXCEPT CRO ---------------------------------------------
  useEffect(() => {
    if (!isCro) dispatch(getAllProjects());
  }, [isCro, dispatch]);
  useEffect(() => {
    dispatch(getCROlistUnderProject(FOUNDATION_DEPARTMENT_ID));
  }, [dispatch]);
  // ---------------------------------------------------------

  //---------- DispatchParams ---------------------------------
  const dispatchParams = useMemo(
    () => ({
      project_id: project?.id === -1 ? null : project?.id,
      cro_id: cro?.userID ?? null,
      year,
      month: month?.id,
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      sortBy: tableState?.sort?.field,
      sortOrder: tableState?.sort?.direction,
    }),
    [project, year, month, cro, tableState?.page, tableState?.search, tableState?.sort, tableState?.pageSize],
  );

  //---------* =-=-=-==-=--=-=-=-=- *---------------------------

  //-------------- Table Fetch ------------------------------
  useEffect(() => {
    dispatch(getStudentSessionAnalyticsTable(dispatchParams));
  }, [dispatchParams, dispatch]);
  //-------------* Table Fetch *-----------------------------

  return (
    <GlobalWrapper title={'Student Session Analytics'}>
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
          <GlobalSelectFieldWithoutFormikNew
            data={MONTHS_WITHOUT_ALL}
            keys={{
              itemId: 'id',
              itemValue: 'name',
            }}
            label={'Months'}
            selectedDetails={month}
            setChange={setMonth}
            sx={{
              maxWidth: { xs: '100%', sm: 180 },
            }}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={'Year'}
              views={['year']}
              onChange={(v) => setYear(v?.year() ? v?.year() : dayjs().year())}
              value={dayjs().year(year)}
              sx={{
                maxWidth: { xs: '100%', sm: 180 },
              }}
            />
          </LocalizationProvider>

          {!isCro && (
            <>
              <GlobalSelectFieldWithoutFormikNew
                label={'Project'}
                data={[{ id: -1, name: 'All' }, ...allProjects]}
                keys={{
                  itemId: 'id',
                  itemValue: 'name',
                }}
                selectedDetails={project}
                setChange={setProject}
                sx={{
                  width: { xs: '100%', sm: 200 },
                }}
                disabled={courseLoading}
              />
              <Autocomplete
                id="combo-box-demo"
                getOptionLabel={({ name }) => name ?? ''}
                isOptionEqualToValue={(opt, val) => opt.userID === val?.userID}
                options={crosunderproject}
                onChange={(_, v) => setCRO(v)}
                sx={{ minWidth: 300 }}
                renderInput={(params) => <TextField {...params} label="CRO" />}
              />
            </>
          )}
        </Stack>
        <GlobalTable
          rowUniqueId="sl_no"
          headers={studentSessionAnalyticsHeader}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          rows={studentSessionAnalyticsTable}
          meta={meta}
        />
      </Stack>
    </GlobalWrapper>
  );
}
